import { PATH, PATH_TO_TITLE } from '@repo/constants';
import { useBreadcrumbStore } from '@repo/lib';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Separator,
} from '@ui/components';
import { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';

type BreadcrumbSegment = {
  text: string;
  isLink?: boolean;
  href?: string;
};

export const AppBreadcrumb = () => {
  const location = useLocation();
  const labels = useBreadcrumbStore((state) => state.labels);

  const breadcrumbSegments = useMemo(() => {
    if (location.pathname === PATH.DASHBOARD) {
      return [];
    }

    const paths = location.pathname.split('/').filter(Boolean);
    const segments: BreadcrumbSegment[] = [
      { text: 'Dashboard', isLink: true, href: PATH.DASHBOARD },
    ];

    if (paths[0]) {
      segments.push({ text: paths[0].replace('-', ' ') });
    }

    const secondLevelPath = `/${paths[0]}/${paths[1]}`;
    if (paths[1] && PATH_TO_TITLE[secondLevelPath]) {
      segments.push({
        text: PATH_TO_TITLE[secondLevelPath],
        isLink: paths[2] !== '0',
        href: `/${paths[0]}/${paths[1]}`,
      });
    }

    const remainingPaths = paths.slice(2);
    remainingPaths.forEach((path, index) => {
      if (path && path !== '0') {
        const fullPath = `/${paths.slice(0, index + 3).join('/')}`;
        segments.push({
          text: labels[fullPath] || path,
          isLink: false,
        });
      }
    });

    return segments;
  }, [location.pathname, labels]);

  if (location.pathname === PATH.DASHBOARD) {
    return null;
  }

  return (
    <>
      <Separator
        className="h-5"
        orientation="vertical"
      />
      <Breadcrumb>
        <BreadcrumbList>
          {breadcrumbSegments.map((segment, index) => (
            <BreadcrumbItem key={index}>
              {index > 0 && <BreadcrumbSeparator />}
              {segment.isLink ? (
                <BreadcrumbLink
                  className="text-foreground"
                  asChild
                >
                  <Link to={segment.href!}>{segment.text}</Link>
                </BreadcrumbLink>
              ) : (
                <BreadcrumbPage className="capitalize text-foreground">
                  {segment.text}
                </BreadcrumbPage>
              )}
            </BreadcrumbItem>
          ))}
        </BreadcrumbList>
      </Breadcrumb>
    </>
  );
};
